import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=20dd6ae0&"
import script from "../../models/app/download.ts?vue&type=script&lang=ts&"
export * from "../../models/app/download.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports